import { createContext, useContext } from 'react';
import type { APP_SETTINGS } from '@football-kids/shared/settings';

interface TenantContextValue {
    theme?: any;
    globalStyles?: any;
    config: any;
}

export const TenantContext = createContext<TenantContextValue>(null as unknown as TenantContextValue);

export const useTenantContext = () => {
    const { config } = useContext(TenantContext);
    return config as Partial<typeof APP_SETTINGS>
}
